<script setup>
import {onMounted, ref, watch} from "vue";
import Button from "../../components/forms/Button.vue";
import ServiceRequirementService from "../../services/ServiceRequirementService.js";
import ServiceRequirementsListComponent from "../../components/services-requirements/ServiceRequirementsListComponent.vue";

import {useRoute} from "vue-router";
import router from '@/router';
import {useI18n} from 'vue-i18n';

const route = useRoute();
const {t} = useI18n()

const filter = ref((route.query && route.query.filter) ? route.query.filter : '');
const isLoading = ref(false);

onMounted(() => {
  console.log(filter.value);
});


</script>

<template>

  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-2">
          <a @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> {{ t('serviceRequirementsHistory.back') }}</a>
        </div>
        <div class="col-8 text-center">
          <div class="page-section__title">
            {{ t('serviceRequirementsHistory.service_requests_history') }}
          </div>
        </div>
      </div>
    </div>
    <div class="page-section__content">
        <ServiceRequirementsListComponent/>
    </div>
  </div>



</template>

<style scoped>

</style>
